export default [
  {
      code: 'C0001',
      user_message: 'A system configuration error has been detected.',
      support_message:
      'When patient search completes, it takes a general path in the form /dashbaord/patient/:patientId/screen/somescreen and replaces :patientId with the id of the searched patient. In this case, :patientId did not appear in that general path. This most likely means no search path was configured in this system. Check that each item in System Admin > search config has been assigned a value.'
  }
]